import type { ReactNode } from "react";
import { createPortal } from "react-dom";

/**
 * Renders a modal into `document.body` instead of where it sits in the tree.
 *
 * `.mx-modal-backdrop` is `position: fixed; inset: 0`, which is viewport-
 * relative ONLY while no ancestor establishes a containing block. Any
 * ancestor with `transform`, `filter`, `backdrop-filter`, `perspective`,
 * `contain` or `will-change` does — and the app header carries
 * `backdrop-blur-*`. A dialog opened from the header switcher therefore had
 * its backdrop clamped to the header's 1280×70 box and its centred panel
 * pushed to y = -109: the title was cut off above the viewport.
 *
 * Wrap any modal that can be opened from inside the header (or any other
 * blurred/transformed container) in this. Modals rendered from a page body
 * don't need it, but it is harmless there.
 */
export function ModalPortal({ children }: { children: ReactNode }) {
	if (typeof document === "undefined") return null;
	return createPortal(children, document.body);
}
